import React, { forwardRef } from 'react';
import SideNavigationDefault from './internal/SideNavigationDefault';
import SideNavigationAnchor from './internal/SideNavigationAnchor';
import SideNavigationDropdown from './internal/SideNavigationDropdown';
export var SideNavigationVariants;
(function (SideNavigationVariants) {
    SideNavigationVariants["default"] = "default";
    SideNavigationVariants["anchor"] = "anchor";
})(SideNavigationVariants || (SideNavigationVariants = {}));
const SideNavigation = forwardRef(({ config, ...props }, ref) => {
    switch (config.variant) {
        case SideNavigationVariants.default:
            return (React.createElement(SideNavigationDefault, { ...config, ...props, ref: ref }));
        case SideNavigationVariants.anchor:
            return (React.createElement(SideNavigationAnchor, { ...config, ...props, ref: ref }));
        default:
            return (React.createElement(SideNavigationDefault, { ...config, ...props, ref: ref }));
    }
});
SideNavigation.displayName = 'SideNavigation';
export default SideNavigation;
export { SideNavigationDropdown };
